/*
 * Public API Surface of ng2-charts
 */

export * from './lib/ng-charts.module';
export * from './lib/base-chart.directive';
export * from './lib/theme.service';
export * from './lib/base-colors';
